import { MigrationStrategies } from 'rxdb';
import { AssetDetailsDocument } from './assetDetails.types';

export const assetDetailsMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: AssetDetailsDocument) => {
    const newDoc = {
      ...oldDoc,
    };
    delete newDoc.assetFiles.inspectorId;
    return newDoc;
  },
  2: (oldDoc: AssetDetailsDocument) => {
    const newDoc = {
      ...oldDoc,
      etapFields: [
        {
          etapId: 0,
          assetId: '',
          etapAssetId: '',
          workingDistance: '',
          totalEnergy: 0,
          kv: '',
          afb: '',
          site: 0,
          discipline: 0,
          dateModified: '',
          dateCreated: '',
        },
      ],
    };
    return newDoc;
  },
  3: (oldDoc: AssetDetailsDocument) => oldDoc,
};
